import { Box, Grid, TextField, Button, Typography } from '@mui/material';

const ActiveUsersTools = ({
    startDate, setStartDate,
    endDate, setEndDate,
    fetchStats, data = []
}) => {
    const activeUsersCount = data.length;

    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={2} alignItems="center" flexWrap="wrap">
                <Typography variant="h6" sx={{ mr: 1, mt: 1 }}>
                    משתמשים פעילים ({activeUsersCount})
                </Typography>

                <Grid item>
                    <TextField
                        label="מתאריך"
                        type="date"
                        size="small"
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item>
                    <TextField
                        label="עד תאריך"
                        type="date"
                        size="small"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item>
                    <Button variant="contained" size="small" onClick={fetchStats}>
                        טען
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ActiveUsersTools;
